import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwSelectComponent } from './cdw-select/cdw-select.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule],
  declarations: [CdwSelectComponent],
  exports: [CdwSelectComponent],
})
export class CdwSelectModule {}
